<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>category</md-icon>
          </div>
          <h4 class="title">Add Software</h4>
        </md-card-header>

        <form @submit.prevent="add">
          <md-card-content>
            <div class="text-right">
              <md-button @click="goBack" class="md-primary md-dense">
                Back to List
              </md-button>
            </div>

            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Name
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="software.name" />
                  <validation-error :errors="apiValidationErrors.name" />
                </md-field>
              </div>
            </div>

            <!-- <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Category
              </label>
              <div class="md-layout-item">
                <md-field>
                  <label>Select ...</label>
                  <md-select
                    v-model="categories"
                    @md-selected="updateCategories"
                    name="categories"
                  >
                    <md-option
                      v-for="category in available_categories"
                      :key="category.id"
                      :value="category.id"
                    >
                      {{ category.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div> -->

            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Categories
              </label>
              <div class="md-layout-item">
                <md-field>
                  <label>Select ...</label>
                  <md-select
                    v-model="categories"
                    @md-selected="updateCategories"
                    name="categories"
                    multiple
                  >
                    <md-option
                      v-for="category in available_categories"
                      :key="'category_' + category.id"
                      :value="category.id"
                    >
                      {{ category.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>

            <!-- <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Tags
              </label>
              <div class="md-layout-item">
                <md-field>
                  <label>Select ...</label>
                  <md-select
                    v-model="tags"
                    @md-selected="updateTags"
                    name="tags"
                    multiple
                  >
                    <md-option
                      v-for="tag in available_tags"
                      :key="'tag_' + tag.id"
                      :value="tag.id"
                    >
                      {{ tag.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
 -->

            <md-card-actions md-alignment="right">
              <md-button type="submit" class="md-success">Add Item</md-button>
            </md-card-actions>
          </md-card-content>
        </form>
      </md-card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
  components: { ValidationError },

  mixins: [formMixin],

  data() {
    return {
      software: {
        type: "Software",
        name: null,
        categories: [],
        relationshipNames: ["categories"],
      },

      available_categories: [],
      categories: [],
    };
  },

  created() {
    this.getCategories();
  },

  methods: {
    async add() {
      delete this.software.id;
      this.resetApiValidation();

      try {
        await this.$store.dispatch("softwares/add", this.software);
        this.software = await this.$store.getters["softwares/software"];

        await this.$store.dispatch(
          "alerts/success",
          "Item added successfully."
        );

        this.goBack();
      } catch (e) {
        if (e.response.data.errors[0]) {
          await this.$store.dispatch(
            "alerts/error",
            e.response.data.errors[0].title
          );
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.$store.dispatch(
            "alerts/error",
            "Oops, something went wrong!"
          );
          this.setApiValidation(e.response.data.errors);
        }

        if (this.software.id) {
          await this.$store.dispatch("softwares/destroy", this.software.id);
        }
      }
    },

    updateCategories() {
      this.software.categories = [];
      this.categories.forEach((category) => {
        this.software.categories.push({
          id: category,
          type: "SoftwareCategory",
        });
      });
    },

    // getCategories() {
    //   this.$store.dispatch("softwaresCategories/list").then(() => {
    //     this.available_categories =
    //       this.$store.getters["softwaresCategories/dropdown"];
    //     if (this.available_categories && this.available_categories.length) {
    //       this.software.category.id = this.available_categories[0].id;
    //     }
    //   });
    // },

    getCategories() {
      this.$store.dispatch("softwaresCategories/list").then(() => {
        this.available_categories =
          this.$store.getters["softwaresCategories/dropdown"];
        // if (this.available_categories && this.available_categories.length) {
        //   this.categories.push(this.available_categories[0].id);
        //   this.updateCategories();
        // }
      });
    },

    goBack() {
      this.$router.push({ name: "List Softwares" });
    },
  },
};
</script>

<style lang="scss" scoped>
.spacing {
  padding-bottom: 1rem;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
  padding-left: 0;
  padding-top: 10px;
  min-height: 150px;
}

.md-field:after,
.md-field:before {
  bottom: 10px !important;
}
</style>
<style >
.ck-editor__editable {
  min-height: 200px;
  width: auto;
}
</style>
